<!-- Ported from the Polaris kit: src/product/components/DocumentCard.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs;
     strings moved to i18n by hand. Change the design in the kit first. -->
<script setup>
// A document the agent reads: a page or a PDF, where it comes from, whether the agent can use it yet, and how many answers came out of it.
import { useI18n } from 'vue-i18n';
import { Document16, Launch16, Renew16, TrashCan16 } from '@carbon/icons-vue';
import { Badge } from '../ui/badge';
import { Checkbox } from '../ui/checkbox';
import {
  Item,
  ItemActions,
  ItemContent,
  ItemDescription,
  ItemMedia,
  ItemTitle,
} from '../ui/item';
import MiddleTruncate from './MiddleTruncate.vue';
import RowMenu from './RowMenu.vue';

const props = defineProps({
  name: { type: String, required: true },
  source: { type: String, default: '' }, // the address, or the file name of a PDF
  pdf: Boolean,
  status: { type: String, default: 'available' },
  synced: { type: String, default: '' }, // "Synced 3 hours ago"
  responses: { type: Number, default: 0 },
  selectable: Boolean,
  selected: Boolean,
});
const emit = defineEmits(['select', 'action']);
const STATUS = { available: 'success', processing: 'info', failed: 'warning' };
const { t } = useI18n();

const items = [
  { label: 'Sync now', value: 'sync', icon: Renew16 },
  ...(props.pdf
    ? []
    : [{ label: 'Open the page', value: 'open', icon: Launch16 }]),
  {
    label: 'Delete document',
    value: 'delete',
    icon: TrashCan16,
    destructive: true,
  },
];
</script>

<template>
  <Item
    variant="outline"
    size="sm"
    class="min-w-0 flex-nowrap"
    data-document-card
  >
    <label
      v-if="selectable"
      class="flex size-8 shrink-0 items-center justify-center p-0"
      ><Checkbox
        :model-value="selected"
        :aria-label="`Select ${name}`"
        @update:model-value="emit('select')"
    /></label>
    <ItemMedia variant="icon"><Document16 aria-hidden="true" /></ItemMedia>
    <ItemContent class="min-w-0">
      <ItemTitle class="max-w-full min-w-0">
        <MiddleTruncate :text="name" />
      </ItemTitle>
      <ItemDescription class="truncate">
        {{
          [
            source,
            synced,
            t('POLARIS.CARDS.ANSWERS', responses, { count: responses }),
          ]
            .filter(Boolean)
            .join(' · ')
        }}
      </ItemDescription>
    </ItemContent>
    <ItemActions>
      <Badge :variant="STATUS[status]">
        {{ t(`POLARIS.CARDS.STATUS.${status.toUpperCase()}`) }}
      </Badge>
      <RowMenu
        :label="`Actions for ${name}`"
        :items="items"
        @action="value => emit('action', { action: value })"
      />
    </ItemActions>
  </Item>
</template>
